module.exports = __webpack_public_path__ + "static/img/4.c40fc72.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/sp/4.png
// module id = PgXG
// module chunks = 0